import modalActions from "actions/modal";
import cn from "classnames";
import { DefaultTemplate } from "components/modal/templates";
import Loader from "components/shared/loader";
import Switch from "components/shared/switch";
import React from "react";
import { connect } from "react-redux";
import { getBidItemsChanges } from "sources/bidItemChanges";
import Confirm from "./confirm";
import Form from "./form";
import List from "./list";
import ManualDates from "./manualDates";

class BidItemChangesModal extends DefaultTemplate {
    state = {
        isLoading: !this.props.itemChangesHistory && this.props.bid?.hasItemsChange,
        activeComponent: "list",
        itemChangesHistory: this.props.itemChangesHistory,
        switchPayload: {},
        title: "Перецепки и пересменки по заявке",
    };

    componentDidMount() {
        if (!this.state.isLoading) {
            return;
        }

        getBidItemsChanges(this.props.bid.id, true)
            .then((itemChangesHistory) => this.setState({ itemChangesHistory, isLoading: false }))
            .catch(() => this.setState({ itemChangesHistory: [], isLoading: false }));
    }

    switchComponent = (name, payload = {}) => {
        const titles = {
            list: "Перецепки и пересменки по заявке",
            form: "Запланировать замену в заявке",
            planShow: "Редактирование замены в заявке",
        };
        this.setState({ activeComponent: name, switchPayload: payload, title: titles[name] || this.state.title });
    };

    back = () => this.switchComponent("list");

    calcCname = () => {
        const isForm = ["form", "planShow"].includes(this.state.activeComponent);

        return cn("modal__window modal-window", {
            "modal-window--bid-item-change-form": isForm,
            "modal-window--wide": !isForm,
        });
    };

    renderBody = () => {
        if (this.state.isLoading) {
            return <Loader />;
        }

        return (
            <Switch active={this.state.activeComponent}>
                <Form
                    {...this.props}
                    name="form"
                    {...this.state.switchPayload}
                    switchComponent={this.switchComponent}
                    back={this.back}
                />
                <Form
                    {...this.props}
                    name="planShow"
                    {...this.state.switchPayload}
                    switchComponent={this.switchComponent}
                    back={this.back}
                />
                <ManualDates
                    {...this.props}
                    name="manualDates"
                    {...this.state.switchPayload}
                    setTitle={(title) => this.setState({ title })}
                    back={this.back}
                />
                <Confirm
                    {...this.props}
                    name="confirm"
                    {...this.state.switchPayload}
                    switchComponent={this.switchComponent}
                    back={this.back}
                />
                <List
                    {...this.props}
                    name="list"
                    switchComponent={this.switchComponent}
                    itemChangesHistory={this.state.itemChangesHistory}
                />
            </Switch>
        );
    };
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => {
    return {
        modal: (params) => dispatch(modalActions.open(params)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BidItemChangesModal);
